import { axiosInstance, baseUrl, handleErrors } from "./auth";



export const GET_VENDOR_REPORT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/reportAnalytic`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

export const REVIEW_SERVICES_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/user/review/listRating`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

